import ContactIcon from 'src/assets/icons/contact-icon.svg';
import { FieldMappingsMockUpType } from '../types';

export const selectedData = {
  value: '',
  to_crm_if_blank: true,
  from_sprouts: false,
  nosync: false,
  // crm to sproutes
  toSprouts: true,
  dontSyncToSprouts: false,
};

export const ContactsFieldMappings: FieldMappingsMockUpType = {
  id: 'contacts',
  label: 'Contact',
  testRunId: 'contacts',
  testRunLabel: 'Contacts',
  icon: ContactIcon,
  desc: 'Fields mapped',
  count: '0',
  entity: 'Contact',
  sproutsFields: [
    {
      label: 'First Name',
      id: 'firstname',
      fieldType: 'String',
      selectedData,
      testValue: 'firstName',
      required: true,
    },
    {
      label: 'Last Name',
      id: 'lastName',
      fieldType: 'String',
      selectedData,
    },
    {
      label: 'Email',
      id: 'emailId',
      fieldType: 'String',
      selectedData,
      required: true,
      optionalWithValue: 'Email/Linkedin Url',
    },
    {
      label: 'Linkedin Url',
      id: 'linkedinUrl',
      fieldType: 'String',
      selectedData,
      required: true,
      optionalWithValue: 'Email/Linkedin Url',
    },
    {
      label: 'Email verification status',
      id: 'emailVerificationStatus',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      featureFlag: 'validateEmail',
      onlyOutbound: true,
    },
    {
      label: 'Email Source',
      id: 'emailEnrichmentSource',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      onlyOutbound: true,
    },
    {
      label: 'HPM Subject',
      id: 'messageSubject',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      isAiField: true,
      onlyOutbound: true,
    },
    {
      label: 'HPM Message',
      id: 'hpmMessage',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      isAiField: true,
      onlyOutbound: true,
    },
    {
      label: 'HPM Follow up',
      id: 'hpmFollowUpMessage',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      isAiField: true,
      onlyOutbound: true,
    },
    {
      label: 'HPM Second Follow up',
      id: 'hpmSecondFollowUpMessage',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      isAiField: true,
      onlyOutbound: true,
    },
    {
      label: 'Linkedin Post Connection Follow Up',
      id: 'postLinkedinFollowUp1',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      isAiField: true,
      onlyOutbound: true,
    },
    {
      label: 'Linkedin Post Connection Second Follow Up',
      id: 'postLinkedinFollowUp2',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      isAiField: true,
      onlyOutbound: true,
    },
    {
      label: 'Call Script',
      id: 'callScriptMessage',
      selectedData,
      fieldType: 'String',
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      isAiField: true,
      onlyOutbound: true,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Buyer Role',
      id: 'buyerRoles',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      isAiField: true,
      onlyOutbound: true,
    },
    {
      label: 'Buyer Rationale',
      id: 'buyerRolesRationale',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      isAiField: true,
      onlyOutbound: true,
    },
    // {
    //   label: 'HPM Connection Request',
    //   id: 'hpmConnectionRequest',
    //   fieldType: 'String',
    //   selectedData,
    //   supportedTypes: ['String', 'Set', 'List', 'Object'],
    //   isAiField: true,
    //   onlyOutbound: true,
    // },
    {
      label: 'Linkedin Post Connection',
      id: 'hpmPostConnectionRequest',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      isAiField: true,
      onlyOutbound: true,
    },
    {
      label: 'Account Name',
      id: 'companyName',
      fieldType: 'String',
      selectedData,
      testValue: 'companyName',
      isAccountField: true,
    },
    {
      label: 'Domain',
      id: 'companyDomain',
      fieldType: 'String',
      selectedData,
      testValue: 'companyDomain',
      onlyOutbound: true,
      isAccountField: true,
    },
    {
      label: 'Account Linkedin Url',
      id: 'companyLinkedInUrl',
      fieldType: 'String',
      selectedData,
      testValue: 'companyLinkedInUrl',
      onlyOutbound: true,
      isAccountField: true,
    },
    {
      label: 'Industry',
      id: 'companyIndustry',
      fieldType: 'String',
      selectedData,
      testValue: 'companyIndustry',
      supportedTypes: ['String'],
      onlyOutbound: true,
      isAccountField: true,
    },
    {
      label: 'Annual Revenue',
      id: 'companyAnnualRevenue',
      fieldType: 'Integer',
      selectedData,
      onlyOutbound: true,
      isAccountField: true,
    },
    {
      label: 'HQ Country',
      id: 'companyHQCountry',
      fieldType: 'String',
      selectedData,
      onlyOutbound: true,
      isAccountField: true,
    },
    {
      label: 'Account Country',
      id: 'companyCountry',
      fieldType: 'String',
      selectedData,
      onlyOutbound: true,
      isAccountField: true,
    },
    {
      label: 'State',
      id: 'companyState',
      fieldType: 'String',
      selectedData,
      onlyOutbound: true,
      isAccountField: true,
    },
    {
      label: 'List Name',
      id: 'tagName',
      fieldType: 'String',
      selectedData,
      onlyOutbound: true,
    },
    {
      label: 'Job Title',
      id: 'title',
      fieldType: 'String',
      selectedData,
    },
    {
      label: 'Seniority',
      id: 'designation',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      onlyOutbound: true,
    },
    {
      label: 'Sub-Seniority',
      id: 'catalogerSubDesignation',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      onlyOutbound: true,
    },
    // {
    //   label: 'List Name',
    //   id: 'listName',
    //   selectedData,
    // },
    {
      label: 'Contact Owner',
      id: 'contactOwner',
      fieldType: 'String',
      selectedData,
      testValue: 'uploadedBy',
      supportedTypes: ['String', 'Set', 'List', 'Object'],
    },
    {
      label: 'Campaign Stage',
      id: 'currentCmpStage',
      fieldType: 'String',
      selectedData,
      defaultMapValues: 'campaignStage',
      supportedTypes: ['String', 'Set', 'List', 'Object'],
    },
    {
      label: 'Lifecycle Stage',
      id: 'lifecycleStage',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
    },
    {
      label: 'Department',
      id: 'department',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
      onlyOutbound: true,
    },
    {
      label: 'Employee Count Range',
      id: 'noOfEmployeeRange',
      fieldType: 'String',
      selectedData,
      onlyOutbound: true,
      isAccountField: true,
    },
    {
      label: 'Technologies',
      id: 'technologies',
      fieldType: 'String',
      typeId: 'Technology Stack',
      selectedData,
      onlyOutbound: true,
    },
    // {
    //   label: 'Facebook Url',
    //   id: 'facebookUrl',
    //   fieldType: 'String',
    //   selectedData,
    // },
    {
      label: 'Enriched Phone(Primary)',
      id: 'enrichedPhoneNumber',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String'],
      onlyOutbound: true,
    },
    {
      label: 'Enriched Phone(Others)',
      id: 'contactPhoneNumbers',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String'],
      onlyOutbound: true,
    },
    {
      label: 'Phone Number',
      id: 'phoneNo',
      fieldType: 'String',
      selectedData,
    },
    {
      label: 'User Added Phone',
      id: 'prospectWorkPhone',
      fieldType: 'String',
      selectedData,
    },
    {
      label: 'Country',
      id: 'country',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
    },
    {
      label: 'City',
      id: 'city',
      fieldType: 'String',
      selectedData,
    },
    {
      label: 'State',
      id: 'state',
      fieldType: 'String',
      selectedData,
    },
    {
      label: 'Connection Path',
      id: 'connectionPath',
      fieldType: 'String',
      selectedData,
    },
    {
      label: 'Opt-Out',
      id: 'isOptedOut',
      fieldType: 'Boolean',
      selectedData,
      supportedTypes: ['Boolean'],
    },
    {
      label: 'Excluded',
      id: 'isExcluded',
      fieldType: 'Boolean',
      selectedData,
      supportedTypes: ['Boolean'],
    },
    {
      label: 'Lead',
      id: 'isLead',
      fieldType: 'Boolean',
      selectedData,
      supportedTypes: ['Boolean'],
    },
    {
      label: 'Contact SDR Owner',
      id: 'sdrOwnerEmail',
      fieldType: 'String',
      selectedData,
    },
    {
      label: 'Contact Status',
      id: 'campaignStatus',
      fieldType: 'String',
      selectedData,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
    },
    {
      label: 'Contact Stage',
      id: 'contactStage',
      fieldType: 'String',
      selectedData,
    },
    {
      label: 'Employee Count (Min)',
      id: 'noOfEmployeeMin',
      fieldType: 'Integer',
      selectedData,
      onlyOutbound: true,
      supportedTypes: ['String', 'Integer', 'Long'],
      isAccountField: true,
    },
    {
      label: 'Employee Count (Max)',
      id: 'noOfEmployeeMax',
      fieldType: 'Integer',
      selectedData,
      onlyOutbound: true,
      supportedTypes: ['String', 'Integer', 'Long'],
      isAccountField: true,
    },
    {
      label: 'Sub Department',
      id: 'catalogerDivisions',
      fieldType: 'String',
      selectedData,
      onlyOutbound: true,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
    },
    {
      label: 'Source',
      id: 'uploadType',
      fieldType: 'String',
      selectedData,
      onlyOutbound: true,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
    },
    {
      label: 'Last Visited Date',
      id: 'lastModifiedDate',
      fieldType: 'Date',
      selectedData,
      onlyOutbound: true,
      supportedTypes: ['String', 'Set', 'List', 'Object', 'Date'],
    },
    {
      label: 'Added on Sprouts',
      id: 'insertedAt',
      fieldType: 'String',
      selectedData,
      onlyOutbound: true,
      supportedTypes: ['String', 'Set', 'List', 'Object', 'Date'],
    },
    {
      label: 'Updated At Sprouts',
      id: 'updatedAt',
      fieldType: 'String',
      selectedData,
      onlyOutbound: true,
      supportedTypes: ['String', 'Set', 'List', 'Object', 'Date'],
    },
    {
      label: 'Job Last Changed',
      id: 'jobChangedDate',
      fieldType: 'Timestamp',
      selectedData,
      onlyOutbound: true,
      supportedTypes: ['String', 'Set', 'List', 'Object', 'Date'],
    },
    {
      label: 'Technology',
      id: 'techStack',
      fieldType: 'String',
      selectedData,
      onlyOutbound: true,
      supportedTypes: ['String', 'Set', 'List', 'Object'],
    },
    {
      label: 'Total Deliveries',
      id: 'deliveriesCount',
      selectedData,
      supportedTypes: ['String', 'Integer', 'Long'],
      onlyOutbound: true,
    },
    {
      label: 'Total Opens',
      id: 'opensCount',
      selectedData,
      supportedTypes: ['String', 'Integer', 'Long'],
      onlyOutbound: true,
    },
    {
      label: 'Total Clicks',
      id: 'clicksCount',
      selectedData,
      supportedTypes: ['String', 'Integer', 'Long'],
      onlyOutbound: true,
    },
    {
      label: 'Total Replies',
      id: 'repliesCount',
      selectedData,
      supportedTypes: ['String', 'Integer', 'Long'],
      onlyOutbound: true,
    },
    {
      label: 'Last Delivery Date',
      id: 'deliveryDate',
      selectedData,
      supportedTypes: ['String', 'Date'],
      onlyOutbound: true,
    },
    {
      label: 'Last Open Date',
      id: 'lastOpenDate',
      selectedData,
      supportedTypes: ['String', 'Date'],
      onlyOutbound: true,
    },
    {
      label: 'Last Reply Date',
      id: 'lastReplyDate',
      selectedData,
      supportedTypes: ['String', 'Date'],
      onlyOutbound: true,
    },
    {
      label: 'Last Call Date',
      id: 'lastCallDate',
      selectedData,
      supportedTypes: ['String', 'Date'],
      onlyOutbound: true,
    },
  ],
};